import Vue from 'vue'

const client = Vue.prototype.$api

export default {
  getProfessionalInsurers (profId) {
    return client.get('professionals/insurers', { params: { profId: profId } })
  },
  getCenterInsurers (centerId) {
    return client.get('centers/insurers', { params: { centerId: centerId } })
  },
  getInsurers (criteria = { specialty: null, professional: null, service: null, location: null }) {
    return client.get('/insurers', { params: criteria })
  },
  getAllProfInsurers (specialty = null) {
    return client.get('professionals/insurers', { params: { specialty }})
  },
  getAllCenterInsurers () {
    return client.get('centers/insurers')
  }
}


// WEBPACK FOOTER //
// ./src/repositories/InsurersRepository.js